import { render, staticRenderFns } from "./ObjectName.vue?vue&type=template&id=95d5f388&"
import script from "./ObjectName.vue?vue&type=script&lang=js&"
export * from "./ObjectName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports